import type { ReactNode } from 'react'
import { Label } from '@/shared/ui/label'

interface FormFieldProps {
  label: string
  required?: boolean
  /** Hiển thị nhãn "(tùy chọn)" mờ bên cạnh label để phân biệt rõ các field không bắt buộc. */
  optional?: boolean
  /** Nhãn tuỳ biến cho trạng thái optional; mặc định lấy từ i18n key common.optional. */
  optionalLabel?: string
  error?: string | undefined
  children: ReactNode
  hint?: string | undefined
  /** Id của control được liên kết với label qua htmlFor. */
  id?: string
}

export function FormField({
  label,
  required,
  optional,
  optionalLabel,
  error,
  children,
  hint,
  id,
}: FormFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>
        {label}
        {required && <span className="ml-0.5 text-red-500">*</span>}
        {optional && !required && (
          <span className="ml-1.5 text-xs font-normal text-zinc-400">
            ({optionalLabel ?? 'tùy chọn'})
          </span>
        )}
      </Label>
      {children}
      {hint && <p className="text-xs text-zinc-400">{hint}</p>}
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  )
}
